import { Modal } from "antd";
import { Button } from "../account/misc/Button";

interface CancelRegistrationModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export default function CancelRegistrationModal({ visible, onCancel, onConfirm }: CancelRegistrationModalProps) {
  return (
    <Modal className={"clean one"} visible={visible} onCancel={onCancel} zIndex={100001}>
      <header>
        <h2>Cancel registration?</h2>
      </header>

      <p>
        Anything you've entered so far will be cleared and you'll return to the login screen.
      </p>

      <footer>
        <Button type={"Cancel"} onClick={onCancel}>
          <span>Keep going</span>
        </Button>
        <Button type={"Primary"} onClick={onConfirm}>
          <span>Cancel &amp; sign in</span>
        </Button>
      </footer>
    </Modal>
  );
}
